
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Siyavar Ramchandra Kee Jay</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm musical-comp section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Siyavar  <span> Ramchandra Kee Jay</span></h2>
        </div>
        <div class="row">
            <div class="col-md-8">
                <p>The play "Siyavar Ramchandra Kee Jay," organized by Radhika Creations in association with Raisoni
                    Group of Institutions, is set to captivate audiences of all ages. This megaplay features the
                    participation of 75 talented children and boasts a power-packed performance lasting 2 hours and 15
                    minutes, divided into two parts known as "aanki natak."
                </p>
                <p> "Siyavar Ramchandra Kee Jay'' beautifully recounts the centuries-old story of Prabhu Shriram,
                    serving as a narration of our history and celebrating the triumph of good over evil. This play
                    guarantees entertainment and leaves a lasting impact. Radhika Creations, a remarkable establishment,
                    is the brainchild of child artists. It provides a nurturing environment for children to explore
                    their imaginations freely and create their own worlds. Here, they learn the art of acting, drama
                    creation, and performance. With over 5 years of presence in Pune and more than 10 years in Nagpur,
                    Radhika Creations is dedicated to training children in theatre, showcasing children's theatre
                    performances, and consistently providing family entertainment.
                </p>
                <p>Children at Radhika Creations showcase a variety of talents throughout their presentations,
                    including dance, music, art, and sports. The mission of the company goes beyond stage productions.
                    It aims to train the next generation of performers for the industry, promote overall personality
                    development, build confidence, improve mental stamina and patience, and instill in kids a sense of
                    togetherness, teamwork, selfless service, and patriotism.

                </p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/siyavr-ram.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

    </div>
</section>
